require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./package-ahrefs-bs-dotenv.json") })
        }
      }, "path---package-ahrefs-bs-dotenv");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---package-ahrefs-bs-dotenv!./.cache/json/package-ahrefs-bs-dotenv.json
// module id = 743
// module chunks = 231608221292675